// Points are px relative to the stage's center; `focus` is stored rather than a translate so an outside zoom change stays centered.

export type Point = { x: number; y: number };
export type Size = { width: number; height: number };

export const NO_FOCUS: Point = { x: 0, y: 0 };

export type ImageFit = "contain" | "cover";

export function fittedSize(natural: Size, stage: Size, mode: ImageFit = "contain"): Size {
  if (!natural.width || !natural.height) return stage;
  const scales = [stage.width / natural.width, stage.height / natural.height];
  const fit = mode === "cover" ? Math.max(...scales) : Math.min(...scales);
  return { width: natural.width * fit, height: natural.height * fit };
}

export function clampFocus(focus: Point, fitted: Size, stage: Size, zoom: number): Point {
  const limit = (image: number, view: number) => Math.max(0, image / 2 - view / (2 * zoom));
  const clamp = (value: number, max: number) => (max === 0 ? 0 : Math.min(max, Math.max(-max, value)));
  return {
    x: clamp(focus.x, limit(fitted.width, stage.width)),
    y: clamp(focus.y, limit(fitted.height, stage.height)),
  };
}

export function zoomFocus(focus: Point, anchor: Point, from: number, to: number): Point {
  return {
    x: focus.x + anchor.x / from - anchor.x / to,
    y: focus.y + anchor.y / from - anchor.y / to,
  };
}

export function panFocus(focus: Point, delta: Point, zoom: number): Point {
  return { x: focus.x - delta.x / zoom, y: focus.y - delta.y / zoom };
}
